<template>
  <ValidationObserver
    ref="MessageTemplatesObserver"
    v-slot="{ valid, pristine }" >
    <b-modal
      id="message-templates-modal"
      ref="messagetemplatesModal"
      :modal-class="['settings-modal', {success: successInfoScreen, 'white-bg': noPermission }]"
      centered
      scrollable-not
      hide-header-close
      :static="staticModal"
      :class="{ 'static-modal': staticModal }"
      :no-fade="noFade"
      :title="modalTitle"
      size="lg"
      no-close-on-backdrop
      @hidden="resetFields"
      @hide="emitHide"
      @shown="focus" >
      <template slot="modal-title">
        <div
          class="flex flex-align-center" >
          <div
            class="flex flex-align-center"
            :class="{ 'back-title': backAction }"
            @click="runBackAction">
            <SBIcon
              v-if="backAction"
              class="mr-2 rotate-90"
              :icon="SBIconList.DOWN_ARROW"
              :color="SBColors.blackUltralight"
              :size="12" />
            <img
              src="~@/assets/img/wa-logo-small.png"
              alt="whatsapp logo"
              width="26"
              style="margin-right: 2px;">
            <p class="greedy title">New Message Template</p>
          </div>
          <span class="greedy" />
          <SBIcon
            id="title-description"
            class="ml-1"
            :icon="SBIconList.INFORMATION"
            :color="SBColors.greyPrimary"
            :size="12" />
          <b-popover
            target="title-description"
            triggers="hover"
            placement="top" >
            <h1>When to use WhatsApp Message Templates?</h1>
            <p>Create a Message Template to initiate or respond to a WhatsApp conversation if more than 24 hours have passed since the last message.</p>
            <p>Visit
              <a
                href="https://developers.facebook.com/docs/whatsapp/message-templates/guidelines"
                target="_blank">
                Creating Message Templates
              </a>
              for more information.</p>
          </b-popover>
        </div>
      </template>
      <template v-if="successInfoScreen">
        <div class="success-info-message flex column center">
          <span class="success-icon" />
          <h5>Message Template was successfully submitted for a WhatsApp review</h5>

          <p>Your Message Template needs to get approved by WhatsApp so you can use it to communicate with your contacts. If it gets approved we'll notify you.</p>
          <p>You can track the approval status of your Message Template in the <router-link :to="{ name: 'MessageTemplates', params: { numberId: businessId } }" @click.native="abort" >number settings</router-link>.</p>
        </div>
      </template>
      <Forbidden v-else-if="noPermission" />
      <template v-else>
        <div
          class="preview-body flex">
          <Spinner
            v-if="!newTemplateConfig.language"
            style="height: 100%;"
            :size="14"
            :thickness="2" />
          <template v-else >
            <div class="greedy">
              <b-form
                @submit="onSubmit">
                <!-- latinOnly rule is available if needed -->
                <ValidationProvider
                  v-slot="{ errors, dirty }"
                  name="Name"
                  rules="required" >
                  <b-form-group>
                    <label
                      for="p-key"
                      class="settings__label mt-0" >
                      Name
                    </label>
                    <div class="relative">
                      <input
                        ref="nameInputRef"
                        v-model="template.name"
                        type="text"
                        class="w-100 sb2-bordered sb2-hoverable sb2-focusable"
                        placeholder="Enter Message Template name"
                        @input="validateName" >
                      <Spinner
                        v-if="checkingNameExistance"
                        :size="16"
                        :thickness="2"
                        class="small checking-input" />
                    </div>
                    <div
                      v-if="(errors[0] || numberError) && dirty"
                      class="error flex flex-align-center">
                      <SBIcon
                        class="mr-2"
                        :icon="SBIconList.ERROR"
                        :color="SBColors.redPrimary"
                        :size="12" />
                      <span>{{ errors[0] || numberError }}</span>
                    </div>
                  </b-form-group>
                </ValidationProvider>

                <!-- <div
                  v-if="!editMode"
                  class="row">
                  <div class="type-field"> -->
                <ValidationProvider
                  v-slot="{ errors }"
                  ref="typeValidationRef"
                  name="Type"
                  rules="required" >
                  <b-form-group>
                    <label
                      for="p-key"
                      class="settings__label" >
                      Type
                    </label>
                    <div id="type-wrapper">
                      <multiselect
                        v-model="template.category"
                        :placeholder="typeOpen ? 'Search type' : 'Select type'"
                        class="flex-options hide-tags no-selected-background"
                        :options="types"
                        :disabled="editMode"
                        label="text"
                        track-by="value"
                        :multiple="false"
                        :show-labels="false"
                        :show-no-results="true"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :allow-empty="false"
                        :searchable="true"
                        @open="typeOpen = true"
                        @close="closedType" >
                        <template
                          #noResult
                          class="no-result">
                          <span>No results</span>
                        </template>
                        <template
                          slot="option"
                          slot-scope="props">
                          <SBIcon
                            :icon="SBIconList.DONE_TICK"
                            :color="SBColors.bluePrimary"
                            :size="9"/>
                          <span class="ellipsis">
                            {{ props.option.text }}
                          </span>
                        </template>
                      </multiselect>
                      <b-popover
                        v-if="editMode"
                        target="type-wrapper"
                        triggers="hover"
                        placement="bottom"
                        custom-class="basic-popover" >
                        This can't be edited
                      </b-popover>
                    </div>
                    <div
                      v-if="errors[0]"
                      class="error flex flex-align-center">
                      <SBIcon
                        class="mr-2"
                        :icon="SBIconList.ERROR"
                        :color="SBColors.redPrimary"
                        :size="12" />
                      <span>{{ errors[0] }}</span>
                    </div>
                  </b-form-group>
                </ValidationProvider>
                  <!-- </div> -->

                  <!-- Looks like language is not needed any more so let's skipp it and make it more simple for the user. -->
                  <!-- <div class="col-sm-6 lang-field">
                    <ValidationProvider
                      v-slot="{ errors }"
                      ref="langValidationRef"
                      name="Language"
                      rules="required">
                      <b-form-group>
                        <label
                          for="p-key"
                          class="settings__label" >
                          Language
                        </label>
                        <div id="language-wrapper">
                          <multiselect
                            v-model="template.language"
                            :placeholder="languageOpen ? 'Search language' : 'Select language'"
                            class="flex-options hide-tags no-selected-background"
                            :options="languages"
                            :disabled="editMode"
                            label="name"
                            track-by="code"
                            :multiple="false"
                            :show-labels="false"
                            :show-no-results="false"
                            :clear-on-select="false"
                            :preserve-search="true"
                            :allow-empty="false"
                            :searchable="true"
                            @open="languageOpen = true"
                            @close="closedLang" >
                            <template
                              slot="option"
                              slot-scope="props">
                              <SBIcon
                                :icon="SBIconList.DONE_TICK"
                                :color="SBColors.bluePrimary"
                                :size="9"/>
                              <span class="ellipsis">
                                {{ props.option.name }}
                              </span>
                            </template>
                          </multiselect>
                          <b-popover
                            v-if="editMode"
                            target="language-wrapper"
                            triggers="hover"
                            placement="bottom"
                            custom-class="basic-popover" >
                            This can’t be edited
                          </b-popover>
                        </div>
                        <div
                          v-if="errors[0]"
                          class="error flex flex-align-center">
                          <SBIcon
                            class="mr-2"
                            :icon="SBIconList.ERROR"
                            :color="SBColors.redPrimary"
                            :size="12" />
                          <span>{{ errors[0] }}</span>
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </div> -->
                <!-- </div> -->

                <ValidationProvider
                  v-if="!editMode"
                  v-slot="{ errors }"
                  ref="messageValidationProviderRef"
                  name="Message"
                  :rules="{
                    required: true,
                    noStartingPlaceholder: true,
                    noEndingPlaceholder: true,
                    noNeighbourPlaceholders: true,
                    noPlaceholderNewline: true,
                    tooLong: {
                      max: maxMessageLength,
                      current: rawCounter,
                      message: 'Message is too long. Maximum is 1024 characters.',
                    }
                  }"
                  :bails="false" >
                  <b-form-group>
                    <label
                      for="text-field"
                      class="settings__label flex flex-align-center" >
                      <span>Message</span>
                      <SBIcon
                        id="message-description"
                        class="ml-1"
                        :icon="SBIconList.INFORMATION"
                        :color="SBColors.greyPrimary"
                        :size="12" />
                      <span
                        class="character-counter greedy mx-0"
                        :class="{ error: rawCounter > maxMessageLength }">{{ maxMessageLength - rawCounter }}</span>
                    </label>
                    <SBTextInput
                      id="text-field"
                      ref="messageArea"
                      v-model="template.text"
                      :disabled="editMode"
                      :focus-shadow="true"
                      placeholder="Enter message..."
                      show-tags-select
                      tag-counter-mode
                      @raw-input="rawInput"
                      @tag-count="tagCounterUpdate"
                      @tab="tabPressed" />
                    <b-popover
                      v-if="editMode"
                      target="text-field"
                      triggers="hover"
                      placement="bottom"
                      custom-class="basic-popover" >
                      This can’t be edited
                    </b-popover>
                    <template v-if="errors.length">
                      <div
                        v-for="(err, index) in errors"
                        :key="index"
                        class="error flex flex-align-center">
                        <SBIcon
                          class="mr-2"
                          :icon="SBIconList.ERROR"
                          :color="SBColors.redPrimary"
                          :size="12" />
                        <span>{{ err }}</span>
                      </div>
                    </template>
                    <b-popover
                      target="message-description"
                      triggers="hover"
                      placement="bottom" >
                      <h1>Message content</h1>
                      <p>Add the content of your message here. You can add text, emojis, or include variables, which allows you to add unique information such as specific names, locations, or tracking numbers when sending the Message Template.</p>
                      <p>Visit
                        <a
                          href="https://developers.facebook.com/docs/whatsapp/message-templates/guidelines/"
                          target="_blank">
                          Creating Message Templates
                        </a>
                        for more information.</p>
                    </b-popover>
                  </b-form-group>
                </ValidationProvider>

                <ValidationProvider
                  v-if="!editMode"
                  v-slot="{ errors }"
                  name="Media"
                  rules="required" >
                  <b-form-group>
                    <label
                      for="p-key"
                      class="settings__label flex flex-align-center" >
                      Media
                      <SBIcon
                        id="media-description"
                        class="ml-1"
                        :icon="SBIconList.INFORMATION"
                        :color="SBColors.greyPrimary"
                        :size="12" />
                    </label>
                    <div id="attachment-wrapper">
                      <multiselect
                        ref="attachmentElementRef"
                        v-model="template.attachment"
                        placeholder="Select an option"
                        class="flex-options hide-tags no-selected-background"
                        :options="mediaTypes"
                        :disabled="editMode"
                        label="name"
                        track-by="code"
                        :multiple="false"
                        :show-labels="false"
                        :show-no-results="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :allow-empty="false"
                        :preselect-first="true"
                        :searchable="false"
                        @input="resetExample" >
                        <template
                          slot="option"
                          slot-scope="props">
                          <p>{{ props.option.name }}</p>
                        </template>
                      </multiselect>
                      <b-popover
                        v-if="editMode"
                        target="attachment-wrapper"
                        triggers="hover"
                        placement="bottom"
                        custom-class="basic-popover" >
                        This can’t be edited
                      </b-popover>
                    </div>
                    <div
                      v-if="errors[0]"
                      class="error flex flex-align-center">
                      <SBIcon
                        class="mr-2"
                        :icon="SBIconList.ERROR"
                        :color="SBColors.redPrimary"
                        :size="12" />
                      <span>{{ errors[0] }}</span>
                    </div>
                    <b-popover
                      target="media-description"
                      triggers="hover"
                      placement="bottom">
                      <h1>Media attachment</h1>
                      <p>Enable media so you can send images, documents, or videos as an attachment to the Message Template content.</p>
                      <p>Visit
                        <a
                          href="https://developers.facebook.com/docs/whatsapp/message-templates/guidelines/"
                          target="_blank">
                          Creating Message Templates
                        </a>
                        for more information.</p>
                    </b-popover>
                  </b-form-group>
                </ValidationProvider>

                <ValidationProvider
                  v-if="!editMode && template && template.attachment && template.attachment.name !== 'None'"
                  v-slot="{ errors }"
                  name="Media Example"
                  rules="required" >
                  <b-form-group>
                    <label
                      for="p-key"
                      class="settings__label flex flex-align-center" >
                      {{ template.attachment.name }} example
                      <SBIcon
                        id="example-description"
                        class="ml-1"
                        :icon="SBIconList.INFORMATION"
                        :color="SBColors.greyPrimary"
                        :size="12" />
                    </label>
                    <div id="attachment-wrapper">
                      <DropZone
                        ref="dropZone"
                        v-model="files"
                        :placeholder="documentPlaceholder"
                        :extensions="allowedTemplateMessageAttachments(template.attachment.code)"
                        :max-file-size="16000000"
                        @error="(shown) => blockError = shown" />
                    </div>
                    <div
                      v-if="!blockError && errors[0]"
                      class="error flex flex-align-center">
                      <SBIcon
                        class="mr-2"
                        :icon="SBIconList.ERROR"
                        :color="SBColors.redPrimary"
                        :size="12" />
                      <span>{{ errors[0] }}</span>
                    </div>
                    <b-popover
                      target="example-description"
                      triggers="hover"
                      placement="bottom">
                      <h1>Media example</h1>
                      <p>Add example media for the Message Template to be approved.</p>
                    </b-popover>
                  </b-form-group>
                </ValidationProvider>

                <!-- BUTTONS -->
                <ValidationProvider
                  v-if="!editMode"
                  v-slot="{ errors }"
                  name="buttons"
                  rules="required" >
                  <b-form-group>
                    <label
                      for="p-key"
                      class="settings__label flex flex-align-center" >
                      Interactive buttons
                      <!-- <SBIcon
                        id="buttons-description"
                        class="ml-1"
                        :icon="SBIconList.INFORMATION"
                        :color="SBColors.greyPrimary"
                        :size="12" /> -->
                    </label>
                    <div id="buttons-wrapper">
                      <multiselect
                        v-model="buttonType"
                        placeholder="Select an option"
                        class="flex-options hide-tags no-selected-background"
                        :options="buttonTypes"
                        label="name"
                        track-by="code"
                        :multiple="false"
                        :show-labels="false"
                        :show-no-results="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :allow-empty="false"
                        :preselect-first="true"
                        :searchable="false" >
                        <template
                          slot="option"
                          slot-scope="props">
                          <p>{{ props.option.name }}</p>
                        </template>
                      </multiselect>
                    </div>
                    <div
                      v-if="errors[0]"
                      class="error flex flex-align-center">
                      <SBIcon
                        class="mr-2"
                        :icon="SBIconList.ERROR"
                        :color="SBColors.redPrimary"
                        :size="12" />
                      <span>{{ errors[0] }}</span>
                    </div>
                    <!-- <b-popover
                      target="buttons-description"
                      triggers="hover"
                      placement="bottom">
                      <h1>Interactive buttons</h1>
                      <p>Create buttons that let customers respond to your message or take action.</p>
                    </b-popover> -->
                    <p
                      v-if="buttonType && buttonType.code === 'buttons'"
                      class="button-description" >Create up to 3 buttons that let customers respond to your message or take action.</p>
                    <p
                      v-if="buttonType && buttonType.code === 'actions'"
                      class="button-description" >Create up to 2 buttons that let customers call a phone number or visit a website link.</p>
                  </b-form-group>
                </ValidationProvider>

                <template v-if="!editMode && buttonType && buttonType.code === 'buttons'">
                  <div
                    v-for="(button, index) in buttons"
                    :key="index"
                    class="button-fields" >
                    <ValidationProvider
                      v-slot="{ errors, failedRules }"
                      :name="`buttons-${index}`"
                      :rules="{
                        required: true,
                        noDuplicate: {
                          list: butonTitles.filter((bt, bi) => bi !== index),
                          caseSensitive: false,
                          message: 'Each button must have a unique title.'
                        }
                      }"
                      :custom-messages="{required: 'Button title is required.'}">
                      <b-form-group>
                        <label
                          :for="`buttonInput-${index}`"
                          class="settings__label flex flex-align-center" >
                          <span class="greedy">Button title</span>
                          <span class="character-counter">{{ buttonMaxTextLength - button.value.length }}</span>
                        </label>
                        <div class="option">
                          <input
                            :id="`buttonInput-${index}`"
                            :ref="`buttonInputRef-${index}`"
                            v-model="button.value"
                            :maxlength="buttonMaxTextLength"
                            type="text"
                            class="w-100 sb2-active sb2-bordered sb2-hoverable sb2-focusable option-item mb-0"
                            placeholder="Enter button title" >
                          <SBIcon
                            v-if="buttons.length > 1"
                            class="mr-2 delete"
                            :icon="SBIconList.CLOSE_THIN"
                            :size="10"
                            :hover-size="20"
                            :color="SBColors.greyPrimary"
                            :background-color="SBColors.white"
                            :hover-icon-color="SBColors.blackPrimary"
                            @click="removeOption(index)" />
                        </div>
                        <div
                          v-if="errors[0] && !failedRules.noDuplicate"
                          class="error flex flex-align-center">
                          <SBIcon
                            class="mr-2"
                            :icon="SBIconList.ERROR"
                            :color="SBColors.redPrimary"
                            :size="12" />
                          <span>{{ errors[0] }}</span>
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </div>

                  <div
                    v-if="buttons.length < 3"
                    class="add-more-btn"
                    @click="addNewButtons">
                    <span class="flex flex-align-center">
                      <SBIcon
                        class="mr-2"
                        :icon="SBIconList.PLUS"
                        :color="SBColors.bluePrimary"
                        :size="8" />
                      <span>Add button</span>
                    </span>
                  </div>
                </template>

                <template v-if="!editMode && buttonType && buttonType.code === 'actions'">
                  <div
                    v-for="(button, index) in actionButtons"
                    :key="index"
                    class="action-button-fields" >
                    <!-- <ValidationProvider
                      v-slot="{ errors }"
                      :name="`button-${index}`"
                      class="flex"
                      :rules="{
                        required: index === 0,
                      }"> -->
                    <div class="flex">
                      <b-form-group class="greedy">
                        <div class="action-option">
                          <b-row>
                            <div class="col-6">
                              <ValidationProvider
                                v-slot="{ errors }"
                                name="Media"
                                rules="required">
                                <b-form-group>
                                  <label
                                    for="p-key"
                                    class="settings__label flex flex-align-center" >
                                    Type of action
                                  </label>
                                  <multiselect
                                    v-model="button.actionType"
                                    class="flex-options hide-tags no-selected-background"
                                    :options="index ? actionTypesSecondButton : actionTypesFirstButton"
                                    label="name"
                                    track-by="code"
                                    :multiple="false"
                                    :show-labels="false"
                                    :show-no-results="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    :allow-empty="false"
                                    :preselect-first="true"
                                    :searchable="false" >
                                    <template
                                      slot="option"
                                      slot-scope="props">
                                      <p>{{ props.option.name }}</p>
                                    </template>
                                  </multiselect>
                                </b-form-group>
                              </ValidationProvider>
                            </div>

                            <div class="col-6">
                              <ValidationProvider
                                v-slot="{ errors }"
                                :name="`button-${index}`"
                                rules="required">
                                <b-form-group>
                                  <label
                                    :for="`actionButtonInput-${index}`"
                                    class="settings__label flex flex-align-center" >
                                    <span class="greedy">Button title</span>
                                    <span class="character-counter">{{ buttonMaxTextLength - button.value.length }}</span>
                                  </label>
                                  <div class="option">
                                    <input
                                      :id="`buttonInput-${index}`"
                                      :ref="`buttonInputRef-${index}`"
                                      v-model="button.value"
                                      :maxlength="buttonMaxTextLength"
                                      type="text"
                                      class="w-100 sb2-active sb2-bordered sb2-hoverable sb2-focusable option-item mb-0"
                                      placeholder="Enter button title" >
                                  </div>
                                  <div
                                    v-if="errors[0]"
                                    class="error flex flex-align-center">
                                    <SBIcon
                                      class="mr-2"
                                      :icon="SBIconList.ERROR"
                                      :color="SBColors.redPrimary"
                                      :size="12" />
                                    <span>Button title is required.</span>
                                  </div>
                                </b-form-group>
                              </ValidationProvider>
                            </div>
                          </b-row>
                          <!-- Type of acction specific row -->
                          <b-row style="margin-top: 10px;">
                            <!-- Phone type -->
                            <ValidationProvider
                              v-if="button.actionType && button.actionType.code === 'phone'"
                              v-slot="{ errors, failedRules }"
                              :name="`phone-${index}`"
                              class="col-12"
                              rules="required|phone:full"
                              :custom-messages="{required: 'Please enter a phone number.'}">
                              <b-form-group>
                                <label
                                  :for="`actionButtonInput-${index}`"
                                  class="settings__label flex flex-align-center" >
                                  <span class="greedy">Phone number</span>
                                  <span class="character-counter">{{ phoneMaxTextLength - button.phone.length }}</span>
                                </label>
                                <div class="option">
                                  <input
                                    :id="`actionButtonInput-${index}`"
                                    :ref="`buttonInputRef-${index}`"
                                    v-model="button.phone"
                                    :maxlength="phoneMaxTextLength"
                                    type="text"
                                    class="w-100 sb2-active sb2-bordered sb2-hoverable sb2-focusable option-item mb-0"
                                    :placeholder="examples.international" >
                                </div>
                                <div
                                  v-if="errors[0]"
                                  class="error flex flex-align-center">
                                  <SBIcon
                                    class="mr-2"
                                    :icon="SBIconList.ERROR"
                                    :color="SBColors.redPrimary"
                                    :size="12" />
                                  <span>{{ errors[0] }}</span>
                                  <template v-if="failedRules.phone">
                                    <SBIcon
                                      id="create-contact-modal-phone-error"
                                      class="ml-1"
                                      :icon="SBIconList.INFO_INVERSE"
                                      color="#ff5b61"
                                      :size="12"/>
                                    <b-popover
                                      target="create-contact-modal-phone-error"
                                      triggers="hover"
                                      placement="bottom"
                                      custom-class="no-pointer-events" >
                                      <h1 class="error-color">Phone number format is wrong</h1>
                                      <p class="strong">Supported international format (E.164)</p>
                                      <p>A phone number in full international format that includes a plus sign (+).</p>
                                      <p><i>Example {{ examples.international }}</i></p>
                                    </b-popover>
                                  </template>
                                </div>
                              </b-form-group>
                            </ValidationProvider>

                            <!-- Website type -->
                            <template v-if="button.actionType && button.actionType.code === 'url'">
                              <div class="col-4">
                                <ValidationProvider
                                  v-slot="{ errors }"
                                  name="Media"
                                  rules="required">
                                  <b-form-group>
                                    <label
                                      for="p-key"
                                      class="settings__label flex flex-align-center" >
                                      URL type
                                    </label>
                                    <multiselect
                                      v-model="button.urlType"
                                      class="flex-options hide-tags no-selected-background"
                                      :options="urlTypes"
                                      label="name"
                                      track-by="code"
                                      :multiple="false"
                                      :show-labels="false"
                                      :show-no-results="false"
                                      :clear-on-select="false"
                                      :preserve-search="true"
                                      :allow-empty="false"
                                      :preselect-first="true"
                                      :searchable="false" >
                                      <template
                                        slot="option"
                                        slot-scope="props">
                                        <p>{{ props.option.name }}</p>
                                      </template>
                                    </multiselect>
                                  </b-form-group>
                                </ValidationProvider>
                              </div>
                              <div class="col-8">
                                <div class="flex">
                                  <ValidationProvider
                                    v-slot="{ errors }"
                                    :name="`url-${index}`"
                                    class="greedy"
                                    rules="required|urlPrefixed"
                                    :custom-messages="{required: 'Please enter a valid URL.'}">
                                    <b-form-group>
                                      <label
                                        :for="`actionButtonInput-${index}`"
                                        class="settings__label flex flex-align-center" >
                                        <span class="greedy">Website URL</span>
                                        <span class="character-counter">{{ urlMaxTextLength - button.url.length }}</span>
                                      </label>
                                      <div class="option">
                                        <input
                                          :id="`actionButtonInput-${index}`"
                                          :ref="`buttonInputRef-${index}`"
                                          v-model="button.url"
                                          :maxlength="urlMaxTextLength"
                                          type="text"
                                          class="w-100 sb2-active sb2-bordered sb2-hoverable sb2-focusable option-item mb-0"
                                          placeholder="https://example.com/" >
                                      </div>
                                      <div
                                        v-if="errors[0]"
                                        class="error flex flex-align-center">
                                        <SBIcon
                                          class="mr-2"
                                          :icon="SBIconList.ERROR"
                                          :color="SBColors.redPrimary"
                                          :size="12" />
                                        <span>{{ errors[0] }}</span>
                                      </div>
                                    </b-form-group>
                                  </ValidationProvider>

                                  <span
                                    v-if="button.urlType && button.urlType.code === 'dynamic'"
                                    class="dynamic-url-part">{1}</span>
                                </div>
                              </div>
                            </template>
                          </b-row>
                        </div>
                        <!-- <div
                          v-if="errors[0]"
                          class="error flex flex-align-center">
                          <SBIcon
                            class="mr-2"
                            :icon="SBIconList.ERROR"
                            :color="SBColors.redPrimary"
                            :size="12" />
                          <span>Button is required</span>
                        </div> -->
                      </b-form-group>
                      <SBIcon
                        v-if="actionButtons.length > 1"
                        class="delete show-hand"
                        style="margin-left: 7px; margin-right: -5px; align-self: center;"
                        :icon="SBIconList.CLOSE_THIN"
                        :size="10"
                        :hover-size="20"
                        :color="SBColors.greyPrimary"
                        :hover-icon-color="SBColors.blackPrimary"
                        @click="removeActiveOption(index)" />
                    </div>
                      
                    <!-- </ValidationProvider> -->
                  </div>

                  <div
                    v-if="actionButtons.length < 2"
                    class="add-more-btn"
                    @click="addNewActionButtons">
                    <span class="flex flex-align-center">
                      <SBIcon
                        class="mr-2"
                        :icon="SBIconList.PLUS"
                        :color="SBColors.bluePrimary"
                        :size="8" />
                      <span>Add button</span>
                    </span>
                  </div>
                </template>

                <!-- <div class="modal-attention-note">
                  <SBIcon
                    :icon="SBIconList.ERROR"
                    :color="SBColors.blackPrimary"
                    :size="12" />
                  <p v-if="editMode">Once a WhatsApp Message Template has been submitted only the name can be edited, but not the content.</p>
                  <p v-else>Create a Message Template so you can initiate a WhatsApp conversation or respond to a conversation if more than 24 hours have passed from the last message sent by the contact.
                    <br>Visit
                    <a
                      :href="whatsappMessageTemplatesCreation"
                      target="_blank"
                    >Creating Message Templates</a>
                    for more information.
                  </p>
                </div> -->

                <div
                  v-if="error || testButtonsTitleError"
                  class="error-message left fs-14 mt-3 flex flex-align-center px-0" >
                  <SBIcon
                    class="mr-2"
                    :icon="SBIconList.ERROR"
                    :color="SBColors.redPrimary"
                    :size="12" />
                  {{ testButtonsTitleError ? testButtonsTitleError : error.message ? error.message : error }}
                </div>
              </b-form>
            </div>
            <div class="no-shrink preview SB-border left">
              <div class="flex column center-all">
                <span v-if="!template.text && !hasAttachment && !buttonsPreview.length" style="font-size: 40px;">💬</span>
                <div
                  v-else
                  class="template-message-wrapper"
                  :class="{ document: hasAttachment, buttons: buttonType && buttonType.code }" >
                  <div
                    class="template-message"
                    :class="{ buttons: buttonType && buttonType.code }">
                    <pdf
                      v-if="template.attachment && template.attachment.code && template.attachment.code.toLowerCase() === 'document' && exampleUrl"
                      class="attachment"
                      :class="[template.attachment.code.toLowerCase(), { placeholder: !exampleUrl, 'document-overlay': exampleUrl && template.attachment.code.toLowerCase() === 'document' }]"
                      :src="exampleUrl" />
                    <div
                      v-else-if="hasAttachment"
                      class="attachment"
                      :class="[template.attachment.code.toLowerCase(), { placeholder: !exampleUrl, 'video-overlay': exampleUrl && template.attachment.code.toLowerCase() === 'video' }]"
                      :style="{ 'background-image': `url(${exampleUrl})` }" />

                    <!-- No user input is rendered here. -->
                    <!-- eslint-disable vue/no-v-html  -->
                    <div
                      v-if="template.text"
                      class="message-body tag-content"
                      v-html="whatsAppFormatToHTML(templateConvertedText)" />

                    <div
                      v-if="!template.text && !hasAttachment"
                      class="skeleton" />
                  </div>

                  <!-- BUTTONS -->
                  <template v-if="buttons">
                    <div
                      v-for="(button, index) in buttonsPreview"
                      :id="`button-${index}`"
                      :key="index"
                      class="button" >
                      <img
                        v-if="button.icon"
                        :src="button.icon.dark"
                        height="12"
                        class="menu-icon mr-2" >
                      <span
                        v-if="button.title"
                        class="ellipsis" >{{ button.title }}</span>
                      <span
                        v-else
                        class="skeleton" />
                      <!-- Only allow copy if the url or phone button -->
                      <div
                        v-if="['PHONE_NUMBER', 'URL'].includes(button.type)"
                        class="copy-me-wrapper">
                        <div
                          v-clipboard="button.value || button.title"
                          class="copy-me"
                          @success="copyToClipboard"
                          @error="copyToClipboard(false)" />
                      </div>
                      <b-popover
                        v-if="['PHONE_NUMBER', 'URL'].includes(button.type)"
                        :target="`button-${index}`"
                        boundary="window"
                        triggers="hover"
                        placement="top"
                        :delay="{ show: 50, hide: 0 } "
                        custom-class="basic-popover button-popover" >
                        <template v-if="button.value">
                          {{ button.value.substring(0, 100).replace(/\/\{*\{*\d*\}*\}*$/, '') }}{{ button.value.length > 100 ? '...' : '' }}
                          <span v-if="button.value.endsWith('\{\{1\}\}')" >/</span>
                          <span
                            v-if="button.value.endsWith('\{\{1\}\}')"
                            class="blue" >{{ '\{\{1\}\}' }}</span>
                        </template>
                      </b-popover>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>

      <template
        slot="modal-footer">
        <b-button
          v-if="noPermission"
          @click="hide">
          Close
        </b-button>
        <b-button
          v-if="!noPermission"
          :disabled="saving"
          @click="abort">
          {{ successInfoScreen ? 'Got it' : 'Cancel' }}
        </b-button>
        <b-button
          v-if="!noPermission && !successInfoScreen"
          variant="primary"
          :disabled="saving || !valid || pristine || checkingNameExistance || !nameChecked || !!numberError || !nameWaitingToBeUpdated"
          :class="{loading: saving}"
          class="flex justify-center settings__actions--save"
          @click="postNewTemplate">
          <span>Save</span>
          <Spinner
            v-if="saving"
            :size="14"
            :thickness="2"
            :color="SBColors.white" />
        </b-button>
      </template>
    </b-modal>
  </ValidationObserver>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { debounce } from 'debounce';
import Multiselect from 'vue-multiselect';
import examples from 'libphonenumber-js/examples.mobile';
import { getExampleNumber } from 'libphonenumber-js/max';
import { parsePhoneNumber } from 'libphonenumber-js';
import { getThumbnails } from 'video-metadata-thumbnails';
import pdf from 'vue-pdf';

import api from '@/helpers/api';
import ToasterMixin from '@/mixins/Toaster';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import Spinner from '@/components/common/Spinner';
import SBTextInput from '@/components/business/widgets/SBTextInput';
import { whatsappFormatMessage, convertToTagView, whatsAppFormatToHTML } from '@/helpers/stringHelpers';
import UserPermissionsMixin from '@/mixins/UserPermissions.mixin';
import Forbidden from '@/components/errors/Forbidden';
import DropZone from '../../../common/DropZone';
import { getFileExtension, getMediaType, getMediaTypeForLastMessage, allowedTemplateMessageAttachments } from '../../../../helpers/mediaHelpers';

export default {
  name: 'MessageTemplateModal',
  components: {
    DropZone,
    SBIcon,
    Spinner,
    Multiselect,
    SBTextInput,
    Forbidden,
    pdf,
  },
  mixins: [
    ToasterMixin,
    UserPermissionsMixin,
  ],
  props: {
    businessId: {
      type: String,
      required: true,
      default: '',
    },
    staticModal: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      backActionCallback: () => {},
      saving: false,
      modalTitle: null,
      template: {
        name: null,
        category: {
          text: 'Utility',
          value: 'UTILITY',
        },
        language: {
          name: 'English',
          code: 'en',
        },
        attachment: null,
        text: null,
      },
      messageRawInput: '',
      tagPlaceholders: 0,
      templateInProgress: null,
      createTemplateTimeout: null,
      files: null,
      templateInitialName: '',
      editTemplateId: null,
      checkingNameExistance: false,
      nameChecked: false,
      editMode: false,
      error: null,
      numberError: null,
      successInfoScreen: false,
      typeOpen: false,
      languageOpen: false,
      whatsappMessageTemplatesCreation: 'https://developers.facebook.com/docs/whatsapp/message-templates/creation/',
      whatsappMessageTemplatesGuideline: 'https://developers.facebook.com/docs/whatsapp/message-templates/guidelines/',
      backAction: false,
      noFade: false,
      buttonType: null,
      buttons: [],
      actionButtons: [],
      buttonMaxTextLength: 25,
      phoneMaxTextLength: 25,
      urlMaxTextLength: 2000,
      maxMessageLength: 1020,
      blockError: false,
      exampleUrl: '',
      actionTypes: [
        {
          name: 'Call phone number',
          code: 'phone',
        },
        {
          name: 'Visit website',
          code: 'url',
          // $isDisabled: true,
        },
      ],
      urlTypes: [
        {
          name: 'Static',
          code: 'static',
        },
        {
          name: 'Dynamic',
          code: 'dynamic',
        },
      ],
      examples: {
        national: '',
        international: '',
      },
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      loadingNewTemplateConfig: 'notification/loadingNewTemplateConfig',
      newTemplateConfig: 'notification/newTemplateConfig',
      currentOrganisation: 'organisation/currentOrganisation',
      templateMessageValidationSuccess: 'notification/templateMessageValidationSuccess',
      templateMessageValidationFailed: 'notification/templateMessageValidationFailed',
      apiError: 'notification/apiError',
      userRegion: 'user/region',
    }),
    actionTypesFirstButton() {
      const types = JSON.parse(JSON.stringify(this.actionTypes));
      if (this.actionButtons.length > 1) {
        const disableButton = types.find(t => this.actionButtons[1] && this.actionButtons[1].actionType && t.code === this.actionButtons[1].actionType.code);
        if (disableButton) {
          disableButton.$isDisabled = true;
        }
      }
      return types;
    },
    actionTypesSecondButton() {
      const types = JSON.parse(JSON.stringify(this.actionTypes));
      const disableButton = types.find(t => t.code === this.actionButtons[0].actionType.code);
      if (disableButton) {
        disableButton.$isDisabled = true;
      }
      return types;
    },
    buttonTypes() {
      const buttonTypes = [
        {
          name: 'None',
          code: null,
        },
        {
          name: 'Reply buttons',
          code: 'buttons',
        },
        {
          name: 'Call to action buttons',
          code: 'actions',
        }];

      return buttonTypes;
    },
    buttonsPreview() {
      const buttons = [];
      if (this.buttonType && this.buttonType.code === 'buttons') {
        this.buttons.forEach((b) => {
          buttons.push({
            title: b.value,
          });
        });
      } else if (this.buttonType && this.buttonType.code === 'actions') {
        this.actionButtons.forEach((b) => {
          buttons.push({
            title: b.value,
            icon: {
              dark: b.actionType && b.actionType.code === 'phone' ? 'https://sendbee-media-dev.s3.eu-west-1.amazonaws.com/icons/button_number_dark.svg' : 'https://sendbee-media-dev.s3.eu-west-1.amazonaws.com/icons/button_link_dark.svg',
            },
          });
        });
      }
      return buttons;
    },
    documentPlaceholder() {
      let placeholder = 'Select or drop JPG, JPEG, or PNG here';
      switch (this.template.attachment.code) {
        case 'video':
          placeholder = 'Select or drop MP4 here';
          break;
        case 'document':
          placeholder = 'Select or drop PDF here';
          break;
        default:
          break;
      }
      return placeholder;
    },
    noPermission() {
      return !this.checkPermission('manage_template_messages');
    },
    hasAttachment() {
      return this.template.attachment && this.template.attachment.name !== 'None';
    },
    templateConvertedText() {
      return convertToTagView(whatsappFormatMessage(this.template.text));
    },
    languages() {
      const languages = [];
      if (this.newTemplateConfig.language) {
        if (
          Object.keys(this.newTemplateConfig.language).find(languageShortCode => languageShortCode === this.userRegion.toLowerCase())
        ) {
          languages.push({
            name: this.newTemplateConfig.language[this.userRegion.toLowerCase()],
            code: this.userRegion.toLowerCase(),
          });
        }

        Object.keys(this.newTemplateConfig.language).forEach((languageShortCode) => {
          if (languageShortCode !== this.userRegion.toLowerCase()) {
            languages.push({
              name: this.newTemplateConfig.language[languageShortCode],
              code: languageShortCode,
            });
          }
        });
      }
      return languages;
    },
    rawCounter() {
      const waText = this.template.text ? whatsappFormatMessage(this.template.text) : '';
      const counter = waText.length;

      const newLineRegex = new RegExp(/\n/, 'g');
      const newLineMatches = waText.match(newLineRegex) || [];
      return counter + newLineMatches.length;
    },
    types() {
      const types = [];
      Object.keys(this.newTemplateConfig.category).forEach((categoryCode) => {
        types.push({
          text: this.newTemplateConfig.category[categoryCode],
          value: categoryCode,
        });
      });
      return types;
    },
    mediaTypes() {
      const mediaTypes = [{
        name: 'None',
        code: null,
      }];
      Object.keys(this.newTemplateConfig.attachment).forEach((mediaCode) => {
        mediaTypes.push({
          name: this.newTemplateConfig.attachment[mediaCode],
          code: mediaCode,
        });
      });
      return mediaTypes;
    },
    nameWaitingToBeUpdated() {
      return this.templateInitialName !== this.template.name;
    },
    butonTitles() {
      return this.buttons.map(b => b.value);
    },
    testButtonsTitleError() {
      return Object.keys(this.$refs.MessageTemplatesObserver.errors).some((key) => {
        if (key.startsWith('buttons-') && this.$refs.MessageTemplatesObserver.errors[key].includes('Each button must have a unique title.')) {
          return true;
        }
        return false;
      }) ? 'Each button must have a unique title.' : false;
    },
  },
  watch: {
    apiError(error) {
      this.saving = false;
      if (error.status === 422) {
        
      } else {
        this.errorMessage = error.data.message;
      }
    },
    buttonType() {
      if (this.buttonType && this.buttonType.code === 'buttons') {
        if (!this.buttons.length) {
          this.addNewButtons();
        } else {
          const targetButton = 'buttonInputRef-0';
          setTimeout(() => {
            this.$refs[targetButton][0].focus();
          }, 0);
        }
      } else if (this.buttonType && this.buttonType.code === 'actions') {
        if (!this.actionButtons.length) {
          this.addNewActionButtons();
        } else {
          const targetMenuItem = 'buttonInputRef-0';
          setTimeout(() => {
            this.$refs[targetMenuItem][0].focus();
          }, 0);
        }
      }
    },
    files() {
      this.mediaUrl();
    },
    loadingNewTemplateConfig() {
      if (!this.loadingNewTemplateConfig) {
        this.focus();
        this.template.category = this.types.find(type => type.value === 'UTILITY');
        this.template.language = this.languages.find(lang => lang.code === this.userRegion.toLowerCase());
      }
    },
    templateMessageValidationSuccess() {
      clearTimeout(this.createTemplateTimeout);
      this.$emit('created', this.templateInProgress);
      this.successInfoScreen = true;
      this.saving = false;
    },
    templateMessageValidationFailed() {
      clearTimeout(this.createTemplateTimeout);
      if (this.successInfoScreen) {
        this.hide();
      } else {
        this.saving = false;
        this.error = this.templateMessageValidationFailed.error_message || 'Something went wrong. Please try again or contact support.';
      }
    },
    // CS: Deep watcher
    // template: {
    //   handler(newValue, oldValue) {
    //     console.log(newValue, oldValue);
    //     // this.nameChecked = false;
    //   },
    //   deep: true,
    //   immediate: true,
    // },
  },
  mounted() {
    const phoneNumberExamples = getExampleNumber(this.userRegion, examples);
    this.examples = {
      national: phoneNumberExamples.formatNational(),
      international: phoneNumberExamples.formatInternational(),
    };
  },
  methods: {
    allowedTemplateMessageAttachments,
    whatsAppFormatToHTML,
    ...mapActions({
      loadNewTemplateConfig: 'notification/loadNewTemplateConfig',
    }),
    addNewButtons() {
      this.buttons.push({ value: '' });
      const targetButton = `buttonInputRef-${this.buttons.length - 1}`;
      setTimeout(() => {
        this.$refs[targetButton][0].focus();
      }, 0);
    },
    removeOption(index) {
      this.buttons.splice(index, 1);
    },
    addNewActionButtons() {
      this.actionButtons.push({ actionType: null, value: '', phone: '', url: '' });
      const targetButton = `buttonInputRef-${this.actionButtons.length - 1}`;
      setTimeout(() => {
        this.$refs[targetButton][0].focus();

        if (this.actionButtons[1] && !this.actionButtons[1].actionType) {
          this.actionButtons[1].actionType = this.actionTypesSecondButton.find(a => !a.$isDisabled);
        }
      }, 0);
    },
    removeActiveOption(index) {
      this.actionButtons.splice(index, 1);
    },
    runBackAction() {
      this.backActionCallback();
    },
    mediaUrl() {
      if (this.files && this.files[0]) {
        const mediaType = this.files[0].type ? getMediaType(this.files[0].type) : getMediaType(getFileExtension(this.files[0].name));

        if (mediaType === 'video') {
          this.parseVideoThumbnails(this.files[0]);
          return;
        }

        const URLObj = window.URL || window.webkitURL;
        this.exampleUrl = URLObj.createObjectURL(this.files[0]);
      } else {
        this.exampleUrl = '';
      }
    },
    async parseVideoThumbnails(videoBlob) {
      const thumbnails = await getThumbnails(videoBlob, {
        quality: 0.6,
        start: 0,
        end: 0,
        scale: 0.5,
      });
      const URLObj = window.URL || window.webkitURL;
      this.exampleUrl = URLObj.createObjectURL(thumbnails[0].blob);
    },
    resetExample() {
      this.exampleUrl = '';
      this.files = [];
      if (this.$refs.dropZone) {
        this.$refs.dropZone.clearFiles();
      }
    },
    resetFields() {
      this.editMode = false;
      this.saving = false;
      this.template = {
        name: null,
        category: {
          text: 'Utility',
          value: 'UTILITY',
        },
        language: {
          name: 'English',
          code: 'en',
        },
        attachment: null,
        text: null,
      };
      this.error = null;
      this.successInfoScreen = false;
      this.buttonType = this.buttonTypes[0];
      this.buttons = [];
      this.actionButtons = [];
      this.files = [];
      this.$emit('hidden');
      this.$refs.MessageTemplatesObserver.reset();
    },
    emitHide() {
      // this.$emit('hidden');
    },
    abort() {
      this.$emit('abort');
      this.$refs.messagetemplatesModal.hide();
    },
    show(template = null) {
      this.$refs.MessageTemplatesObserver.reset();
      this.modalTitle = 'New WhatsApp Message Template';
      this.$refs.messagetemplatesModal.show();
      if (this.emptyObject(this.newTemplateConfig)) {
        this.loadNewTemplateConfig(this.businessId).then((response) => {
          if (template && response.status === 200) {
            this.setTemplateForEditing(template);
          }
        });
      } else if (template) {
        this.setTemplateForEditing(template);
      }
    },
    setTemplateForEditing(template) {
      this.editMode = true;
      this.modalTitle = `Edit ${template.name}`;
      this.backActionCallback = template.backAction;
      this.backAction = !!template.backAction;
      this.noFade = template.noFade;
      if (template.forceNew) {
        this.editMode = false;
      }
      this.editTemplateId = template.id;
      this.templateInitialName = template.name;

      let attachment = {};
      if (template.attachment) {
        attachment = {
          name: this.newTemplateConfig.attachment[template.attachment],
          code: template.attachment,
        };
      } else {
        attachment = this.mediaTypes[0];
      }

      if (template.buttons && template.buttons.length) {
        if (template.buttons[0].type === 'QUICK_REPLY') {
          this.buttonType = this.buttonTypes.find(bt => bt.code === 'buttons');
          template.buttons.forEach((b) => {
            this.buttons.push({
              value: b.title,
            });
          });
        } else {
          this.buttonType = this.buttonTypes.find(bt => bt.code === 'actions');

          template.buttons.forEach((b) => {
            const actionType = b.type === 'PHONE_NUMBER' ? 'phone' : 'url';
            this.actionButtons.push({
              actionType: this.actionTypes.find(a => a.code === actionType),
              value: b.title,
              phone: b.type === 'PHONE_NUMBER' ? b.value : '',
              url: b.type === 'URL' ? b.value : '',
            });
          });

          const targetButton = `buttonInputRef-${this.actionButtons.length - 1}`;
          setTimeout(() => {
            this.$refs[targetButton][0].focus();

            if (this.actionButtons[1] && !this.actionButtons[1].actionType) {
              this.actionButtons[1].actionType = this.actionTypesSecondButton.find(a => !a.$isDisabled);
            }
          }, 0);
        }
      }

      this.template = {
        name: template.name ? template.name : template.keyword,
        category: {
          text: this.newTemplateConfig.category[template.category],
          value: template.category,
        },
        language: {
          name: this.newTemplateConfig.language[template.language],
          code: template.language,
        },
        attachment,
        text: template.text,
      };

      if (this.newTemplateConfig.language) {
        this.template.category = this.types.find(type => type.value === 'MARKETING');
        this.template.language = this.languages.find(lang => lang.code === this.userRegion.toLowerCase());
      }
    },
    hide() {
      this.saving = false;
      this.$refs.messagetemplatesModal.hide();
    },
    focus() {
      if (this.$refs.nameInputRef) {
        this.$refs.nameInputRef.focus();
      }
    },
    /** Triggers validation on category field since it is a multiselect and if user opens the list and closes without selecting anything we should run validation and show error. */
    closedType() {
      this.typeOpen = false;
      this.$refs.typeValidationRef.validate();
    },
    /** Triggers validation on language field since it is a multiselect and if user opens the list and closes without selecting anything we should run validation and show error. */
    closedLang() {
      this.languageOpen = false;
      this.$refs.langValidationRef.validate();
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.$refs.MessageTemplatesObserver.validate().then((valid) => {
        if (valid) {
          this.postNewTemplate();
        }
      });
    },
    proccessButtons(formData) {
      const buttons = [];
      if (this.buttonType && this.buttonType.code === 'buttons') {
        this.buttons.forEach((b, i) => {
          buttons.push({
            index: i,
            type: 'QUICK_REPLY',
            title: b.value,
            value: null,
          });
        });
      } else if (this.buttonType && this.buttonType.code === 'actions') {
        this.actionButtons.forEach((b, i) => {
          let bValue;
          if (b.actionType.code === 'phone') {
            const parsedPhone = parsePhoneNumber(b.phone, { extract: false, defaultCountry: this.userRegion });
            bValue = `${parsedPhone.countryCallingCode}${parsedPhone.nationalNumber}`;
          } else if (b.actionType.code === 'url') {
            bValue = b.url;
            if (b.urlType.code === 'dynamic') {
              bValue = bValue.replace(/\/+$/g, '');
              bValue += '/{{1}}';
            }
          }
          buttons.push({
            index: i,
            type: b.actionType.code === 'phone' ? 'PHONE_NUMBER' : 'URL',
            title: b.value,
            value: bValue,
          });
        });
      }

      if (buttons.length) {
        formData.append('buttons', JSON.stringify(buttons));
      }
    },
    postNewTemplate() {
      this.error = null;
      this.saving = true;
      const formData = new FormData();
      let editTemplateId = '';
      if (this.editMode) {
        formData.append('name', this.template.name);
        editTemplateId = `/${this.editTemplateId}`;
      } else {
        formData.append('name', this.template.name);
        formData.append('text', whatsappFormatMessage(this.template.text));
        formData.append('category', this.template.category.value);
        // formData.append('language', this.template.language.code);
        if (this.template.attachment && this.template.attachment.code) {
          formData.append('attachment', this.template.attachment.code);
        }
        if (this.files && this.files.length) {
          formData.append('example_file', this.files[0]);
        }
      }

      this.proccessButtons(formData);

      api(this.editMode ? 'PUT' : 'POST', `organisation/${this.currentOrganisation.id}/business/${this.businessId}/whatsapp/message-template${editTemplateId}`, formData, null, 'w')
        .then((response) => {
          if (response.status === 200) {
            // this.showToaster(this.editMode ? 'Message Template has been successfully updated.' : 'Message Template has been successfully created.', null, null, 'OK');
            if (this.editMode) {
              this.$emit('updated', {
                templateId: this.editTemplateId,
                newTemplateName: this.template.name,
              });
              this.hide();
            } else {
              this.templateInProgress = response.data;
              clearTimeout(this.createTemplateTimeout);
              this.createTemplateTimeout = setTimeout(() => {
                if (!this.error) {
                  this.$emit('created', this.templateInProgress);
                  this.successInfoScreen = true;
                  this.saving = false;
                }
              }, 10000);
            }
          }
        })
        .catch((error) => {
          this.error = 'Something went wrong! Please try again later.';

          if (error.response && error.response.data && error.response.data.message) {
            this.error = error.response.data.message;
          } else if (error.message) {
            this.error = error.message;
          } else if (error) {
            this.error = error;
          }

          if (!this.error || this.error.indexOf('status code 500') >= 0) {
            this.error = 'Something went wrong! Please try again later.';
          }
          this.saving = false;
        })
        .finally(() => {
          // this.saving = false;
        });
    },
    rawInput(ri) {
      this.messageRawInput = ri.replace(/\n$/g, '');
    },
    tagCounterUpdate(count) {
      this.tagPlaceholders = count;
    },
    // TODO add this to validators during a rewrite but make sure to provide a debounce on the input field.
    //      Make sure validator has an validating flag so we can set the spinner on the input.
    validateName: debounce(async function f() {
      if (this.template.name === this.templateInitialName) {
        // No need to check if the name is already taken.
        return;
      }

      this.numberError = null;
      this.checkingNameExistance = true;
      let nameValid = false;
      const data = {
        limit: 1,
        page: 1,
        name: this.template.name,
      };
      await api('GET', `organisation/${this.currentOrganisation.id}/business/${this.businessId}/whatsapp/message-template/list`, data, null, 'w')
        .then((response) => {
          if (response.status === 200 && (response.data.data.length === 0 || response.data.data[0].name.toLowerCase() !== this.template.name.toLowerCase())) {
            nameValid = true;
          }
        })
        .finally(() => {
          this.checkingNameExistance = false;
        });

      if (!nameValid) {
        this.numberError = 'Message Template name is already taken.';
      }

      this.nameChecked = true;
    }, 500),
    tabPressed() {
      if (this.$refs.attachmentElementRef) {
        this.$refs.attachmentElementRef.$el.focus();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.settings-modal .settings__label {
  margin-top: 15px !important;

  &.mt-0 {
    margin-top: 0 !important;
  }

  .error {
    margin-top: 0 !important;
    color: #FF5B61 !important;
  }
}

.checking-input {
  position: absolute;
  top: 8px;
  right: 8px;
  left: unset;
}

::v-deep #text-field {
  .ql-container {
    height: 72px;
  }
}

.forbidden {
  padding-top: 0 !important;
}

.add-more-btn {
  display: inline-block;
  color: $bluePrimary;
  padding: 0 0 0 0;
  margin-top: 15px;

  span {
    font-weight: 500;
    font-size: 14px;
  }

  &:hover {
    cursor: pointer;
    color: $blackPrimary;
    ::v-deep .sb-icon .mask {
      background-color: $blackPrimary !important;
    }
  }
}

.option {
  position: relative;

  .option-item {
    margin-bottom: 10px;
  }

  .delete {
    // display: none;
    position: absolute;
    top: 7px !important;
    right: 7px !important;
    margin-right: 0 !important;
    cursor: pointer;
  }

  .error {
    margin-top: -5px;
    margin-bottom: 10px;
  }

  &:hover {
    .delete {
      display: flex;
    }
  }
}

.action-button-fields {
  margin-top: 12px;

  &:first-of-type {
    margin-top: 20px;
  }

  .form-group {
    margin-bottom: 0px !important;
  }
}

.action-option {
  background-color: #ffffff;
  padding: 12px 5px;
  box-shadow: 0 1px 3px 0 rgba(68, 76, 100, 0.1) !important;
  border: solid 1px #cfd8dc !important;
  border-radius: 5px !important;

  .row {
    margin-right: 0;
    margin-left: 0;
  }

  [class^='col'], div[class*=' col'] {
    padding: 0 5px;
  }

  .settings__label {
    margin-top: 0px !important;
  }
}

.button-fields {
  .settings__label {
    margin-top: 15px !important;
    font-weight: 400 !important;
  }
}

.button-description {
  margin-top: 8px;
  line-height: 1.21;
  font-size: 14px;
  font-weight: 400;
  color: $blackUltralight;
}

.dynamic-url-part {
  padding-top: 30px;
  padding-left: 10px;
}

.character-counter {
  font-size: 14px !important;
  font-weight: normal !important;
  color: $blackUltralight !important;
  text-align: end;
}

::v-deep .white-bg .modal-body {
  background-color: $white !important;
}

::v-deep .multiselect .multiselect__option.multiselect__option--disabled {
  color: #9EAFB5 !important;
  background: $white !important;
}

.preview-body {
  height: 100%;

  & > div {
    // height: 100%;
    // overflow-y: auto;
    padding: 20px;
  }

  .preview {
    width: 325px;
    background: $white;
    // margin: -20px -20px -20px 20px;
    border-left: 1px solid #E6EBED;

    & > div {
      min-height: 100%;
    }
  }
}

.template-message-wrapper {
  width: fit-content;
  max-width: 288px;

  &.document, &.buttons {
    width: 100%;
  }

  .template-message {
    border-radius: 19px;
    overflow: hidden;
    border: 2px solid $bluePrimary;

    .skeleton {
      background-color: $bluePrimary !important;
      padding: 9px;

      &::after {
        content: '';
        background-color: #7DB3F3 !important;
        display: block;
        height: 12px;
        width: 50%;
        border-radius: 100px;
      }
    }

    .attachment {
      background-color: #f0f6fe;
      height: 95px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      overflow: hidden;

      &.placeholder::after {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        background-image: unset !important;
        background-color: #65a5f1 !important;
        mask: url(~@/assets/img/SB-Icons/doc-new.svg) no-repeat center !important;
        mask-size: 26px 26px !important;
      }

      &.image::after {
        mask: url(~@/assets/img/SB-Icons/image-placeholder.svg) no-repeat center !important;
        mask-size: 26px 26px !important;
      }

      &.video::after {
        mask: url(~@/assets/img/SB-Icons/video-placeholder.svg) no-repeat center !important;
        mask-size: 26px 26px !important;
      }

      &.video.video-overlay::after {
        mask: unset !important;
        mask-size: unset !important;
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        background-image: url('~@/assets/img/video-overlay.svg');
        background-size: 52px;
        background-repeat: no-repeat;
        background-position: center;
        background-color: rgba(red($blackPrimary), green($blackPrimary), blue($blackPrimary), 0.3);
        opacity: 1;
      }

      &.document.document-overlay::before {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        // background-color: rgba(red($blackPrimary), green($blackPrimary), blue($blackPrimary), 0.3);
        background: linear-gradient(225deg, rgba(20,28,32,0.75) 0%, rgba(255,255,255,0) 16%);
        opacity: 1;
        position: absolute;
        top: 0;
      }
      &.document.document-overlay::after {
        mask-image: url('~@/assets/img/SB-Icons/download-arrow.svg') !important;
        mask-size: 16px 16px !important;
        content: '';
        display: block;
        width: 20px;
        height: 20px;
        background-color: $white !important;
        mask-repeat: no-repeat;
        mask-position: center;
        opacity: 1;
        position: absolute;
        top: 5px;
        right: 5px;
      }
    }

    // .show-play-overlay

    .message-body {
      background-color: $bluePrimary;
      padding: 5px 12px;
      white-space: pre-wrap;
      word-wrap: break-word;
      font-size: 14px;
      font-weight: 400;
      line-height: 1.37;
      color: $white;

      ::v-deep .template-tag {
        color: $white !important;
        border-color: $white !important;
        background-color: #4190ed !important;
        margin-right: 1px;
      }
    }

    &.buttons {
      border-bottom-left-radius: 3px;
      border-bottom-right-radius: 3px;
    }

    ::v-deep {
      p {
        min-height: 10px;
      }
    }
  }

  &.document .template-message .message-body {
    padding: 7px 11px;
  }

  .button {
    margin-top: 3px;
    border: 1px solid #b1cff2;
    border-radius: 3px !important;
    color: $bluePrimary;
    background-color: $white;
    width: 100%;
    box-shadow: none;
    justify-content: center;
    overflow: hidden;
    cursor: default;
    position: relative;
    min-height: 32.8px;
    display: inline-flex;
    align-items: center;
    padding: 7px 10px;
    font-size: 14px;
    font-weight: 500;

    .skeleton {
      background-color: $greyBorderModal !important;
      height: 12px;
      width: 50%;
      border-radius: 100px;
    }

    .sb-icon {
      margin-right: 4px;
    }

    .copy-me-wrapper {
      position: absolute;
      opacity: 0;
      right: 5px;
      width: 30px;
      height: 20px;
      background: rgb(255,255,255);
      background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 43%, rgba(255,255,255,1) 100%);

      .copy-me {
        position: absolute;
        right: 0;
        cursor: pointer;
        margin: 4px 0 4px;
        display: block;
        width: 20px;
        height: 12px;
        background-image: url('~@/assets/img/SB-Icons/copy.svg');
        background-repeat: no-repeat;
        background-position: center;

        &:hover {
          background-image: url('~@/assets/img/SB-Icons/copy-hover.svg');
        }
      }
    }

    &:last-of-type {
      border-bottom-left-radius: 19px !important;
      border-bottom-right-radius: 19px !important;
    }

    &:hover .copy-me-wrapper {
      opacity: 1;
    }
  }
}

#attachment-wrapper {
  ::v-deep .error {
    padding: 0 !important;
  }
}
</style>

<style lang="scss">
#message-templates-modal {
  .modal-dialog {
    // max-width: 622px !important;
    max-width: 780px !important;
    width: calc(100% - 16px) !important;
    container: form-input / inline-size;
  }

  // .min-size-query-container {
    
  // }

  .modal-body {
    padding: 0 !important;
  }
}

@container form-input (inline-size < 625px) {
  #message-templates-modal .preview-body {
    flex-direction: column;

    & > div {
      height: unset;
      overflow-y: unset;
    }

    .preview {
      background: $white;
      // margin: 20px 0px -20px -20px;
      width: 100%;
      border-left: none;
      border-top: 1px solid #E6EBED;
    }
  }
}

#text-field {
  .ql-container {
    height: unset !important;
    max-height: unset !important;
  }

  .text-input-wrapper {
    max-height: unset !important;
  }
}

.modal-header {
  h5.modal-title {
    width: 100%;

    .title {
      font-weight: 500;
    }
  }
}

.settings-modal.success {
  .modal-header {
    border-bottom: none !important;

    h5 {
      display: none;
    }
  }

  .modal-body {
    background-color: $white !important;
    padding: 14px 48px 60px !important;

    .success-info-message {
      padding: 20px 40px 60px;
    }

    .success-icon {
      margin-bottom: 15px;
      width: 100%;
      height: 70px;
      background-image: url('~@/assets/img/SB-Icons/whatsapp-submission.svg');
      background-position: center!important;
      background-repeat: no-repeat !important;
      background-size: contain !important;
    }

    h5 {
      font-size: 16px;
      font-weight: 500;
    }

    p {
      font-size: 14px;
      font-weight: 400;
      color: $blackUltralight;
      margin-top: 18px;

      a {
        color: inherit;
        text-decoration: underline;
      }

      .pill {
        padding: 1px 7px 2px;
        border-radius: 3px;
        border: solid 1px #e5e9eb;
        background-color: #edf0f2;
        font-size: 9px;
        font-weight: 500;
        color: $blackPrimary;
      }
    }
  }
}

.modal-body {
  background: red;
  .type-field {
    padding-right: 5px;
  }

  .lang-field {
    padding-left: 5px;
  }
}

.back-title {
  border-radius: 5px;
  padding: 6px 10px 6px 8px;
  margin: -6px -10px;
  cursor: pointer;

  &:hover {
    background-color: $linkHover;
  }
}
</style>
